import React from "react";
import { Link } from "react-router-dom";
import Brand from "../components/Brand";
import Footer from "../components/Footer";

const Terms = () => (
  <>
    <nav className="xnav">
      <div className="wrap nav-in">
        <Link to="/"><Brand /></Link>
        <div className="nav-links">
          <Link to="/" className="btn btn-ghost" style={{ padding: "11px 22px" }} data-testid="back-home-btn">
            Back to home
          </Link>
        </div>
      </div>
    </nav>
    <div className="legal" data-testid="terms-page">
      <Link to="/" className="back">← Back</Link>
      <h1>Terms of Service</h1>
      <p>
        <em>Last updated: December 2025</em>
      </p>
      <p>
        These Terms govern your use of the Xandi Beauty &amp; Wellness Hub waitlist and pre-launch
        website. By joining the waitlist you agree to these Terms and to our{" "}
        <Link to="/privacy">Privacy Policy</Link>.
      </p>

      <h2>1. The waitlist</h2>
      <p>
        Joining the waitlist is free. Submitting your email grants Xandi permission to contact you
        about the launch and your WELCOME15 promo code. You may unsubscribe at any time.
      </p>

      <h2>2. Referral programme</h2>
      <p>
        Each waitlist member receives a unique referral link. When three (3) friends sign up using
        your link, you move ahead in the launch queue. We reserve the right to disqualify
        fraudulent, automated, or duplicate signups at our sole discretion.
      </p>

      <h2>3. WELCOME15 promo code</h2>
      <p>
        WELCOME15 provides 15% off your first booking on the Xandi platform, subject to a maximum
        discount that will be displayed at checkout. The code is non-transferable, has no cash
        value, and cannot be combined with other offers. Xandi may modify or end the promotion at
        any time.
      </p>

      <h2>4. Data protection</h2>
      <p>
        We process your personal information in accordance with Jamaica's Data Protection Act
        (2020). See our <Link to="/privacy">Privacy Policy</Link> for details.
      </p>

      <h2>5. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, Xandi is not liable for indirect, incidental, or
        consequential damages arising from your use of this pre-launch website.
      </p>

      <h2>6. Changes</h2>
      <p>
        We may update these Terms before launch. Significant changes will be communicated to
        waitlist members by email.
      </p>

      <h2>7. Contact</h2>
      <p>
        Xandi Beauty &amp; Wellness Hub Limited ·{" "}
        <a href="mailto:hello@xandibwh.com">hello@xandibwh.com</a> · (876) 599-4444
      </p>

      <p>
        <em>
          This document is provided as placeholder legal text and will be replaced with a final
          version before our public launch.
        </em>
      </p>
    </div>
    <Footer />
  </>
);

export default Terms;
